import { defineMessages } from 'react-intl'

const scope = `procurify.expense.featureSet.ExpenseReportReviseView`

export default defineMessages({
  reviseTabLabel: {
    id: `${scope}.reviseTabLabel`,
    defaultMessage: 'Revise',
  },
  editExpenseLineItemModalTitle: {
    id: `${scope}.editExpenseLineItemModalTitle`,
    defaultMessage: 'Edit expense line',
  },
  editExpenseLineMenuLabel: {
    id: `${scope}.editExpenseLineMenuLabel`,
    defaultMessage: 'Edit expense line',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  resubmitButton: {
    id: `${scope}.resubmitButton`,
    defaultMessage: 'Resubmit',
  },
  duplicateToolbarButton: {
    id: `${scope}.duplicateToolbarButton`,
    defaultMessage: 'Duplicate expense',
  },
  duplicateOverrideConfirmHeader: {
    id: `${scope}.duplicateOverrideConfirmHeader`,
    defaultMessage: 'Confirmation',
  },
  duplicateOverrideConfirmMessage: {
    id: `${scope}.duplicateOverrideConfirmMessage`,
    defaultMessage: 'This action will override the previous expense draft.',
  },
})
